'use strict';
var Promise = require("bluebird");

/*

const createNetwork = (item) => {
    return dynamoParams(process.env.NETWORK_TABLE, item, 'NONE', 'networkID')
    .then(params => {
        return docClient.update(params).promise()
    })
}


*/

const createUpdateExpressions = (item, indexKey, sortKey) =>{
    return new Promise((resolve, reject) => {
       let updateString = 'set'
       for (const key in item) {
            if (key === indexKey || key === sortKey){
                continue
            }


            if (item[key] === '' || item[key] === undefined){
                continue
            }
               if (updateString === 'set'){
                   updateString = `${updateString} #${key} = :${key}`
               }else{
                   updateString = `${updateString}, #${key} = :${key}`
               }
           }
       resolve(updateString)
   })
}

const createExpressionAttributeNames = (item, indexKey, sortKey) =>{
    return new Promise((resolve, reject) => {
        let updatePayload = {}


        for (const key in item) {
            if (key === indexKey || key === sortKey){
                continue
            }


        if (item[key] === '' || item[key] === undefined){
            continue
        }
            updatePayload[`#${key}`] = key
        }
        resolve(updatePayload)
      })
    }


const createExpressionAttributeValues = (item, indexKey, sortKey) =>{
    return new Promise((resolve, reject) => {
        let updatePayload = {}
        for (const key in item) {
            if (key === indexKey || key === sortKey){
                continue
            }

            if (item[key] === '' || item[key] === undefined){
                continue
            }

            updatePayload[`:${key}`] = item[key]
        }
        resolve(updatePayload)
    })
 }
    
module.exports = (tableName, item, returnValue, indexKey, sortKey) => { 
        let params = {}
        params.TableName = tableName;
        params.Key = {}
        params.Key[indexKey] = item[indexKey]
        delete item[indexKey]
        if (sortKey){
            params.Key[sortKey] = item[sortKey]
            delete item[sortKey]
        }
       
        params.ReturnValues = returnValue;

        return createUpdateExpressions(item, indexKey, sortKey)
        .then(expression => {
            params.UpdateExpression= expression;
            return createExpressionAttributeNames(item, indexKey, sortKey)
        })
        .then(names => {
            params.ExpressionAttributeNames = names;
            return createExpressionAttributeValues(item, indexKey, sortKey)
        })
        .then(values => {
            params.ExpressionAttributeValues = values;
            return params
        })
    }


    /*
option for returning reject on nothing returned

      docClient.query(params).promise()
      .then((result) => {
        if ('Message' in result) {
          return Promise.reject(new Error(JSON.stringify(result)));
        } else if ('Attributes' in result) {
          return Promise.resolve(result.Attributes);
        } else if ('Item' in result) {
          return Promise.resolve(result.Item);
        } else if ('Items' in result) {
          return Promise.resolve(result.Item);
        }else {
          console.error(new Error(`No Data Returned from Dynamo verifySuccess: ${JSON.stringify(result)}${moment().format()}`));
          return Promise.reject(new Error('ERROR No User Found!'));
        }
      });


    */


// WEBPACK FOOTER //
// ./src/stores/dynamodb-param.js